enum viewTypeEnum {
  Horizontal,
  Vertical,
}

export default viewTypeEnum;
